<template>
  <div id="reportWrapper">
    <tree-item
      :data="tree"
      :level="0"
    ></tree-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import TreeItem from '@/components/reports/TreeItem'

export default {
  name: 'TreeReport',

  mixins: [
    authMixin
  ],

  components: {
    TreeItem
  },

  data () {
    return {
      copy: null,
      sortColumnId: 0,
      filterListHeight: 250,
      fixedHeaderThreshold: 370
    }
  },

  computed: {
    ...mapGetters({
      auth: 'account/auth',
      tree: 'datasets/tree',
      order: 'reports/order',
      report: 'reports/report',
      bundle: 'bundles/bundle',
      account: 'account/account',
      columns: 'columns/columns',
      filters: 'filters/filters',
      datasets: 'datasets/datasets',
      accessCode: 'accessCodes/accessCode'
    })
  },
}
</script>

<style scoped>
  .field button {
    margin-bottom: 15px;
  }
</style>
